module.exports = __webpack_public_path__ + "img/placas-transito.d330242b.png";